export const organizationKeys = {
  list: () => ['ORGANIZATIONS'],
};
